export default class Counter {
    constructor() {
        this.init();
    }

    init() {
        let elements = document.querySelectorAll('.counter-wrapper');
        elements.forEach((v) => {
            v.numberElement = v.querySelector('.counter-number');
            v.number = v.numberElement.dataset["number"];
            this.addEvents(v);
        });
    }

    addEvents(element) {
        document.addEventListener('aos:in', ({detail}) => {
            if (detail.contains(element)) {
                if (element.interval) {
                    clearInterval(element.interval);
                }
                this.startCounter(element, element.number, 3000);
            }
        });
    }

    startCounter(element, endNumber, duration) {
        let start = 0;
        let increment = endNumber / (duration / 10); // Calculate the increment per second

        element.interval = setInterval(function () {
            start += increment;
            element.numberElement.innerText = Math.round(start);

            if ((increment >= 0 && start >= endNumber) || (increment < 0 && start <= endNumber)) {
                element.numberElement.innerText = endNumber;
                clearInterval(element.interval);
            }
        }, 10);
    }
}
